import { NgModule } from '@angular/core';
import { PaymentSlipsRoutingModule } from './payment-slips-routing.module';
import { PaymentSlipsComponent } from './payment-slips.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DetailModalComponent } from './components/detail-modal/detail-modal.component';
import { PaymentValidateModalComponent } from './components/payment-validate-modal/payment-validate-modal.component';
import { DividerModule } from 'primeng/divider';

@NgModule({
  declarations: [
    PaymentSlipsComponent,
    DetailModalComponent,
    PaymentValidateModalComponent
  ],
  imports: [
    PaymentSlipsRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    CalendarModule,
    InputSwitchModule,
    DividerModule
    ],
  providers: [
    DialogService,
  ]
})
export class PaymentSlipsModule {}
